module.exports = __webpack_public_path__ + "img/nyc.83dd4fa7.jpg";